import { ReflectionStatus } from "../types";
import { REFLECTION_STATUS_MAP } from "../constants";

interface Props {
  status: ReflectionStatus;
}

const ReflectionStatusBadge = ({ status }: Readonly<Props>) => {
  const meta = REFLECTION_STATUS_MAP[status];
  return (
    <div
      className="h-fit px-2 py-0.5 rounded-full w-fit flex items-center gap-1"
      style={{
        backgroundColor: meta.bg,
        color: meta.text,
      }}
    >
      <div
        className="h-[5px] w-[5px] rounded-full"
        style={{
          backgroundColor: meta.statusDotColor,
        }}
      />
      <p className="text-[length:var(--fontSize-helper)] font-medium whitespace-nowrap">
        {meta.label}
      </p>
    </div>
  );
};

export default ReflectionStatusBadge;
